export default __webpack_public_path__ + "static/media/portfolio.027fa4aa.svg";